let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hTSlI")).then(() => parcelRequire('9NngE'));